import { toast } from 'react-toastify'
import { startSxpProxy } from '../../utils/api'
import { CHAT_PROJECT_ID } from '../../utils/constants'
import { allocateApi } from '../bedManagement/modals'
import { makeName } from '../lms/utils'
import { getDoctorName } from '../scheduler/schedulerSlice'
import { AppointmentData } from './appointmentsSlice'
import {
  Appointment,
  AppointmentDemo,
  Encounter,
  Free,
  home,
  mobile,
  Paid,
  PaidConsultation,
  paymentStatus,
  PractitionerRole,
} from './models'
import { labErrorMessages } from '../lms/constants'

export const formatData = (entries: any[]): AppointmentData[] => {
  const appointments = entries?.filter(
    (en: any) => en?.resource?.resourceType === Appointment
  )
  const encounters = entries?.filter(
    (en: any) => en?.resource?.resourceType === Encounter
  )
  const entryObj = entries?.reduce((acc, cur) => {
    const id = cur?.resource?.id
    return { ...acc, [id]: cur }
  }, {})
  const roleObject = entries
    ?.filter((en: any) => en.resource.resourceType === PractitionerRole)
    ?.reduce((acc, cur) => {
      const id = cur.resource?.practitioner?.reference?.split('/')?.[1] ?? ''
      return {
        ...acc,
        [id]: cur.resource?.specialty?.[0]?.coding?.[0]?.display || '',
      }
    }, {})
  const mapped = appointments?.map((app) => {
    let encounterId
    if (encounters?.length) {
      const enc = encounters?.find((e: any) => {
        const refs = e?.resource?.appointment
        if (refs?.length) {
          for (const ref of refs) {
            if (ref?.reference === `Appointment/${app?.resource?.id}`) {
              return true
            }
          }
        }
        return false
      })
      encounterId = enc?.resource?.id
    }
    const participants = app?.resource?.participant
    let patient = participants?.find((p: any) =>
      p?.actor?.reference?.startsWith('Patient')
    )
    if (!patient) return null
    const patientId = patient?.actor?.reference?.split('/')[1]
    patient = entryObj[patientId]
    const telecom = patient?.resource?.telecom?.find(
      (prt: any) => prt.use === mobile
    )
    const telecom2 = patient?.resource?.telecom?.find(
      (prt: any) => prt.use === home
    )
    const slotReference = app.resource.slot?.[0]?.reference
    const slotId = slotReference?.split('/')[1]
    const slot = entryObj[slotId]
    const scheduleReference = slot?.resource?.schedule?.reference
    const scheduleId = scheduleReference?.split('/')?.[1]
    const schedule = entryObj[scheduleId]
    const doctorRef = schedule?.resource?.actor?.[0]?.reference
    const locationRef = schedule?.resource?.actor?.find((sra: any) =>
      sra.reference.startsWith('Location')
    )
    const doctorId = doctorRef?.split('/')?.[1]
    const doctor = entryObj[doctorId]
    const specialty = roleObject[doctorId]
    const meetingLink =
      app.resource.comment && app.resource.comment !== AppointmentDemo
        ? app.resource.comment
        : ''
    const invoiceId =
      app.resource?.identifier?.find((ari: any) => ari.system === paymentStatus)
        ?.value ?? ''
    const thopId = app.resource?.identifier?.[0]?.value ?? ''
    const reasonCode = app.resource?.reasonCode?.[0]?.text ?? ''
    return {
      id: app.resource.id,
      thopId: thopId,
      patientId: patient?.resource?.id ?? '',
      patientName: makeName(patient?.resource?.name),
      patientNumber: telecom?.value ?? telecom2?.value ?? '',
      patientUhid: patient?.resource?.identifier?.[2]?.value ?? '',
      patientThopId: patient?.resource?.identifier?.[0]?.value ?? '',
      slotTiming: slot?.resource?.start ?? app.resource?.start,
      practitioner: getDoctorName(doctor?.resource),
      speciality:
        specialty || app.resource.specialty?.[0]?.coding?.[0]?.display || '',
      status: app.resource.status,
      meetingLink: meetingLink,
      encounter: encounterId,
      invoiceId: invoiceId,
      locationId: locationRef?.reference?.split?.('/')[1],
      consultationType:
        reasonCode && reasonCode !== PaidConsultation ? Free : Paid,
      reasonCode: reasonCode,
    }
  })
  return mapped?.flatMap((x) => (x ? [x] : []))
}
export const patientSearchValue = async (p: string) => {
  try {
    const response = await startSxpProxy(
      CHAT_PROJECT_ID,
      allocateApi?.getPatientDetailsByIdentifier,
      {
        patientIdentifier: p,
      }
    )
    if (response?.data?.entry) {
      return {
        success: true,
        data: response?.data,
      }
    } else {
      return {
        success: false,
        data: null,
      }
    }
  } catch (err) {
    toast?.error(labErrorMessages?.fecthPatient)
    return {
      success: false,
      data: null,
    }
  }
}
